<div [id]="modalId" class="modal" tabindex="-1">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-body text-lem-dark p-3">
                <div class="row">
                    @if (applicationStateService.userData?.bookAccessCode) {
                        <div class="fs-5 col-12 col-lg-4 text-start">Aktive Lizenz: <span class="fs-5 badge text-bg-lem-grey-dark text-uppercase text-white">{{ applicationStateService.userData?.bookAccessCode?.version }}</span></div>
                    } @else {
                        <div class="fs-5 col-12 col-lg-4 text-start">Keine Lizenz <span class="fw-semibold">(Prüfexemplar)</span></div>
                    }
                    <h1 class="text-center text-lg-start col-12 col-lg-8 fw-semibold">In diesem Buch...</h1>
                </div>
                <div class="d-flex flex-column gap-3">
                    <app-section-interactivity [slideConfig]="slideConfig"></app-section-interactivity>
                    <app-section-external-tools [slideConfig]="slideConfig"></app-section-external-tools>
                    @if (applicationStateService.userData?.isTeacher) {
                        <app-section-teacher-information [slideConfig]="slideConfig"></app-section-teacher-information>
                    } @else {
                        <app-section-student-information [slideConfig]="slideConfig"></app-section-student-information>
                    }
                    <app-section-tools [slideConfig]="slideConfig"></app-section-tools>
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <div class="d-flex gap-2 flex-column flex-lg-row align-items-center w-100 justify-content-evenly">
                    <div class="text-start">
                        Hast du weitere Fragen? <a class="text-lem-dark" href="{{ routeService.getAbsoluteRoute('faq', []) }}" target="_blank">FAQ</a> |
                        <a class="text-lem-dark" href="{{ routeService.getAbsoluteRoute('contact', []) }}" target="_blank">Support</a>
                    </div>
                    <div class="text-center">
                        <button class="btn btn-lem-green px-5" data-bs-dismiss="modal" value="zum Buch">zum Buch
                        </button>
                    </div>
                    <div class="text-end">
                        <button (click)="change.emit()" class="btn btn-link text-decoration-none text-lem-dark">
                            <i [class.fa-check-square]="showContent" [class.fa-square]="!showContent" class="fa"></i>
                            Info beim nächsten Besuch anzeigen
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>